import React, { Component } from 'react';
import instagramIcon from './InstagramIcon.png';
import spotifyIcon from './SpotifyIcon.png';
import twitterIcon from './TwitterIcon.png';
import discordIcon from './DiscordIcon.png';
import githubIcon from './GithubIcon.png';
import youtubeIcon from './YoutubeIcon.png';

class LivestreamCreatorDetails extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    let numSubscribers = 0;
    if(this.props.creatorAddress.toLowerCase() in this.props.subscriberStatuses) {
      numSubscribers = Object.keys(this.props.subscriberStatuses[this.props.creatorAddress.toLowerCase()]).length;
    }
    return (
      <div className="flex mt-0 md:py-0 py-4 md:mt-4">
        <div className="rounded-full">
          <img
            className="rounded-full ml-2 mt-0 md:mt-2 lg:mt-0 lg:ml-12 w-16 h-16 lg:w-20 lg:h-20"
            src={this.props.creatorImage}
          />
        </div>
        <div className="ml-8 mt-0 lg:mt-4">
          <div className="text-black dark:text-white text-lg lg:text-2xl font-semibold cursor-pointer">
            {this.props.creatorName}
          </div>
          <div className="text-teal-500 dark:text-teal-400 mt-2 sm:mt-1 text-black text-md lg:text-lg font-semibold cursor-pointer">
            LIVE
          </div>
        </div>
        <div>
          {
            this.props.account != null &&
            this.props.creatorAddress.toLowerCase() in this.props.subscriberStatuses &&
            this.props.account.address.toLowerCase() in this.props.subscriberStatuses[this.props.creatorAddress.toLowerCase()]
              ?
            <div className="flex flex-row">
              <div className="ml-2 lg:ml-8 mt-0 lg:mt-4 cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-24 sm:w-28 h-8 flex justify-center items-center text-sm sm:text-sm text-gray-300 dark:text-gray-400 font-bold bg-zinc-600 dark:bg-zinc-800 rounded-lg">
                Subscribed
              </div>
              <div className="mt-0 lg:mt-4 ml-4 text-black dark:text-white">
                {numSubscribers}
              </div>
              <div className="mt-0 lg:mt-4 ml-2 text-zinc-600 dark:text-gray-400">
                Subscribers
              </div>
            </div>
              :
            <div className="flex flex-row">
              <div className="ml-2 lg:ml-8 mt-0 lg:mt-4 cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-20 lg:w-28 h-8 flex justify-center items-center text-sm sm:text-sm font-bold bg-blue-600 rounded-lg text-white" onClick={() => this.props.selectSubscribeModal()}>
                Subscribe
              </div>
              <div className="mt-0 lg:mt-4 ml-4 text-black dark:text-white">
                {numSubscribers}
              </div>
              <div className="mt-0 lg:mt-4 ml-2 text-zinc-600 dark:text-gray-400">
                Subscribers
              </div>
            </div>
          }
          {
            this.props.socials != null
              ?
            <div className="ml-4 sm:ml-2 lg:ml-8 flex">
              {
                this.props.socials.spotify != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.spotify, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[20px] mt-2" src={spotifyIcon}
                />
                  :
                null
              }
              {
                this.props.socials.instagram != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.instagram, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[20px] mt-2 ml-2" src={instagramIcon}
                />
                  :
                null
              }
              {
                this.props.socials.twitter != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.twitter, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[20px] mt-2 ml-2" src={twitterIcon}
                />
                  :
                null
              }
              {
                this.props.socials.discord != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.discord, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[22px] mt-2 ml-2" src={discordIcon}
                />
                  :
                null
              }
              {
                this.props.socials.github != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.github, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[20px] mt-2 ml-2 rounded-full" src={githubIcon}
                />
                  :
                null
              }
              {
                this.props.socials.youtube != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.youtube, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[22px] mt-2 ml-2 rounded-full" src={youtubeIcon}
                />
                  :
                null
              }
            </div>
              :
            null
          }
        </div>
      </div>
    );
  }
}

export default LivestreamCreatorDetails;
